<template>
    <div @click.self="handleCancel($event)" class="fixed inset-0 bg-gray-700 z-50 flex justify-center items-center transition-all duration-200"
        :class="transition ? 'bg-opacity-50' : 'bg-opacity-0'">
        <div class="bg-white rounded-2xl shadow-lg p-4 w-[350px] bg-opacity-100 grid grid-cols-2 gap-4 transition-all duration-200 ease-out"
            :class="transition ? 'mt-0 opacity-100' : '-mt-12 opacity-0'">
             <div class="col-span-2">
                <div class="flex justify-between items-center">  
                    <!-- title -->
                    <h2 class="text-lg font-medium text-gray-900 pt-1">{{ title ? title : 'Please confirm this action'}}</h2>
                    <LucideIcon name="CircleAlert" :size="32" :stroke-width="2" color="#64748b" />
                </div>
                <!-- descriptive paragraph -->
                <p class="text-sm text-gray-900 pt-2 pb-1">
                    {{message ? message : 'This action requires you to confirm. Click confirm to proceed or close to exit.'}}
                </p>
            </div>
            <CustomButtonModal id="confirm_modal_cancel" text="Cancel" type="navigate" @click="handleCancel($event)"/>
            <CustomButtonModal id="confirm_modal_confirm" :text="confrimationModalButtonText" type="action" @click="handleConfirm($event)"/>
        </div>
    </div>
</template>


<script>
import CustomButtonModal from '@/components/inputs/CustomButtonModal.vue';
import LucideIcon from "@/components/LucideIcon.vue";

export default {
    name: "SuccessModal",
    components: {
        CustomButtonModal,
        LucideIcon
    },
	props: {
		title: String,
		message: String,
        confrimationModalButtonText: {
	type: String,
	default:"Confirm"
	},
	},
    data() {
        return {
            transition: false
        }
    },
    methods: {
        handleConfirm(event) {
            this.transition = false;
            setTimeout(() => this.$emit('confirm', event), 200)
        },
        handleCancel(event) {
            this.transition = false;
            setTimeout(() => this.$emit('cancel', event), 200)
        }
    },
    mounted() {
        this.$nextTick(function() {
            this.transition = true;
        })
        
    }

}
</script>